import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faHeart as faRegularHeart } from "@fortawesome/free-regular-svg-icons";
import axios from "axios";
import { BASE_URL } from "../api/devprofile";
import apiClient from "../api/Apiservice";
import Header from "./Header";
import Slider from "react-slick"; // Import the Slider component
import ReviewsSection from "./ReviewsRatings";
import ReviewCards from "./Reviews";
import PropertiesList from "./PropertiesList";
import DataComponent from "./DataComponent";
import { useLocation, useNavigate } from "react-router-dom";
import { useCityStore } from "../zustand/cityStore";
import pgImage from "../assets/images/pgImage.png";
import MapSection from "./MapSection";
import { useSearchStore } from "../zustand/useSearchStore";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { AiOutlineHeart } from "react-icons/ai";
const HeartIcon = AiOutlineHeart as React.FC<{
  size?: number;
  className?: string;
}>;

interface PropertyData {
  basic_details: {
    propertyname: string;
    city: string;
    houseArea: string;
    location: { latitude: number; longitude: number };
  };
  additional_information: { images: string[] };
  amenities: {
    amenties: { ameneties_name: string; ameneties_images: string }[];
  };
  lowestRent: number;
  overallRating: string;
}

interface Room {
  share_type: string;
  available_beds: number[];
  monthly_rent: number;
}

interface GroupedRooms {
  [key: string]: {
    beds: number;
    lowestPrice: number;
  };
}

const PropertyDetails: React.FC = ({}) => {
  const navigate = useNavigate();
  const photosRef = useRef<HTMLDivElement>(null);
  const occupancyRef = useRef<HTMLDivElement>(null);
  const amenitiesRef = useRef<HTMLDivElement>(null);
  const reviewsRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<HTMLDivElement>(null); // Ref for Map section
  const similarPropertiesRef = useRef<HTMLDivElement>(null); // Ref for Map section
  const [propertiesData, setPropertiesData] = useState<PropertyData[]>([]);
  console.log(propertiesData, ":::::::::::propertiesData in details");
  const [activeSection, setActiveSection] = useState<string>("Photos");
  // Added "Map" to the menu items if you want to include it there too.
  const menuItems = [
    { label: "Photos", ref: photosRef },
    { label: "Occupancy", ref: occupancyRef },
    { label: "Amenities", ref: amenitiesRef },
    { label: "Reviews", ref: reviewsRef },
    { label: "Location", ref: mapRef },
    { label: "more places", ref: similarPropertiesRef },
  ];

  const location = useLocation();
  const { selectedProperty, similarProperties, cityselected } =
    location.state || {};
  console.log(selectedProperty, ":::::::::::selectedProperty");
  console.log(similarProperties, ":::::::::::similarProperties");

  const [property, setProperty] = useState<any>();
  const [propertyData, setPropertyData] = useState<any>();

  const [trendings, setTrendings] = useState<any>([]);
  const [allRooms, setAllRooms] = useState<any>();
  const [allReviews, setAllReviews] = useState<any>();
  const [allReviewMesg, setAllReviewMesg] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showAllAmenities, setShowAllAmenities] = useState(false);
  const { selectedCity } = useCityStore();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMedia, setModalMedia] = useState([]);
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0);
  const [selectedMedia, setSelectedMedia] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState("All");
  const [mediaIndex, setMediaIndex] = useState(0);
  const [currentIndex, setCurrentIndex] = useState(0);

  const occupancyTypes = [
    "All",
    "Single Occupancy",
    "Double Occupancy",
    "Triple Occupancy",
  ];

  console.log(JSON.stringify(property, null, 2));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedProperty]);

  useEffect(() => {
    fetchData();
    // allPrty();
  }, []);

  const formatDateTime = (date: Date): string => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    const fetchProperties = async () => {
      const requestBody = {
        filtering: {
          amenities: [], // ✅ Correct
          pgType: "", // ✅ Correct
          startDate: formatDateTime(new Date()), // Optional Check
          endDate: formatDateTime(new Date()), // Optional Check
          priceRange: {
            min: 0,
            max: 0,
          },
          selectedCity: cityselected || "Bengaluru",
          sorting: "ratings_high_low",
          page_size: 10,
          page_number: 1,
        },
      };

      try {
        const { data, status } = await apiClient.post<PropertyData[]>(
          `${BASE_URL}/zoy_customer/allproperties`,
          requestBody
        );

        if (status === 200) {
          console.log(data, "inside home screen");
          setPropertiesData(data);
        } else {
        }
      } catch (error) {}
    };

    fetchProperties();
  }, [cityselected]);

  const handlePropertyClick = (propertyId: string, propertiesData: any) => {
    // navigate(`/propertyDetails`); // Redirecting to Property Details Page
    const selectedProperty = propertiesData.find(
      (property: any) => property.propertyId === propertyId
    );
    console.log(selectedProperty, "::::::::::::selectedProperty indetails");
    if (selectedProperty) {
      // setSelectedProperty(selectedProperty)
      navigate(`/propertyDetails`, { state: { selectedProperty } });
    } else {
      console.error("Property not found:", propertyId);
    }
  };
  console.log(formatDateTime(new Date()), "::::::::::new Date()");
  const fetchData = async () => {
    try {
      const { data } = await apiClient.get(
        `${BASE_URL}/zoy_customer/${selectedProperty.partnerId}/propertyinfo/${selectedProperty.propertyId}/property_full_details`,
        {
          params: {
            startDate: formatDateTime(new Date()),
            endDate: formatDateTime(new Date()),
          },
        }
      );
      console.log(data, ":::::::::data");
      if (data.length > 0) {
        setProperty(data[0]);
        setAllRooms(data[0].allRooms);
      }
      console.log(
        `${selectedProperty.partnerId}`,"atings_review",
        `${selectedProperty.propertyId}`,"atings_review"
      );
      const res = await apiClient.get(
        `${BASE_URL}/zoy_customer/${selectedProperty.partnerId}/${selectedProperty.propertyId}/get_all_ratings_review`
      );

      console.log(res.data[0], ":::::::::::::selectedProperty.propertyId");
      setAllReviews(res.data[0].ratingData || '');
      setAllReviewMesg(res.data || []);
    } catch (error) {
      console.error("Error fetching property details:", error);
    } finally {
      setIsLoading(false);
    }
  };

  console.log(allReviewMesg[0], ":::::::allReviewMesg");
  const defaultImageUri = require("../assets/images/sign_up.png");

  useEffect(() => {
    if (property && property.length > 0) {
      const trendingData = property.flatMap((partner: any, index: any) => {
        const allImages = partner?.additional_information?.images.map(
          (imageUrl: any) => ({
            imageUri: imageUrl,
          })
        );

        // Filter out invalid URIs (e.g., videos or null values)
        const image = allImages?.filter(
          (item: any) =>
            typeof item.imageUri === "string" &&
            !item.imageUri.includes(".mp4") &&
            item.imageUri !== "null"
        );
        return {
          id: index,
          imageUri:
            image && image.length > 0 ? image[0].imageUri : defaultImageUri,
          name: partner?.basic_details?.propertyname,
          location: partner.basic_details?.city,
          price: partner?.lowestRent,
          rating:
            partner.totalReviews === 0
              ? "No ratings"
              : Number(partner.overallRating) > 0
              ? Number(partner.overallRating)
              : 0,
          userId: partner?.partnerId,
          propertyId: partner?.propertyId,
          pgType: partner?.property_information?.pgType,
        };
      });

      setTrendings(trendingData);
    }
  }, [property]);

  console.log(allRooms, "--------------------allRooms");
  console.log(trendings, "--------------------trendings");

  if (isLoading) {
    return <p className="text-center text-gray-500 py-10">Loading...</p>;
  }

  // Preprocess allRooms data to group by share type
  const groupedRooms: GroupedRooms = allRooms?.reduce((acc: any, room: any) => {
    if (!acc[room.share_type]) {
      acc[room.share_type] = {
        beds: room.available_beds.length,
        lowestPrice: room.monthly_rent,
      };
    } else {
      acc[room.share_type].beds += room.available_beds.length;
      acc[room.share_type].lowestPrice = Math.min(
        acc[room.share_type].lowestPrice,
        room.monthly_rent
      );
    }
    return acc;
  }, {});

  // Slider settings
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const handleViewAllAmenities = () => {
    setShowAllAmenities(true);
  };
  const reviews = {
    overallRating: selectedProperty?.overallRating,
    totalReviews: selectedProperty?.totalReviews,
    data: allReviews,
  };

  // Function to handle smooth scrolling
  const scrollToSection = (section: string, ref: any) => {
    setActiveSection(section);
    ref.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const openModal = (media: any, index: any) => {
    setSelectedMedia(media);
    setCurrentIndex(index);
    setMediaIndex(index);
    setIsModalOpen(true);
  };

  const isVideo = (url: string) => /\.(mp4|mov|h264|webm|ogg)$/i.test(url);

  const renderMedia = (media: string) => {
    if (!media) return null;
    return isVideo(media) ? (
      <video
        src={media}
        controls
        className="w-full h-96 object-contain rounded-lg"
      />
    ) : (
      <img
        src={media}
        alt="Media"
        className="w-full h-full object-cover rounded-lg"
      />
    );
  };

  const groupImagesByOccupancyType = (
    images: string[],
    occupancyType: string
  ) => {
    const groupedImages = images.reduce((acc: any, imageUrl: string) => {
      const type = imageUrl.includes("Double")
        ? "Double Occupancy"
        : "Triple Occupancy";
      if (!acc[type]) {
        acc[type] = [];
      }
      acc[type].push(imageUrl);
      return acc;
    }, {});
    return groupedImages;
  };

  const groupedImages = groupImagesByOccupancyType(
    selectedProperty.additional_information?.images,
    selectedProperty.additional_information.occupancyType
  );

  const filteredMedia =
    activeTab === "All"
      ? selectedProperty?.additional_information?.images?.filter(
          (img: any) => img && img !== "null" && img !== ""
        ) || []
      : groupedImages[activeTab]?.filter(
          (img: any) => img && img !== "null" && img !== ""
        ) || [];

  const goToPrevious = () => {
    setMediaIndex((prev) => (prev === 0 ? filteredMedia.length - 1 : prev - 1));
    setSelectedMedia(
      filteredMedia[
        mediaIndex === 0 ? filteredMedia.length - 1 : mediaIndex - 1
      ]
    );
  };

  const goToNext = () => {
    setMediaIndex((prev) => (prev === filteredMedia.length - 1 ? 0 : prev + 1));
    setSelectedMedia(
      filteredMedia[
        mediaIndex === filteredMedia.length - 1 ? 0 : mediaIndex + 1
      ]
    );
  };

  // Extract coordinates from selectedProperty (assumes valid values)
  const latitude = selectedProperty?.basic_details?.location?.latitude;
  const longitude = selectedProperty?.basic_details?.location?.longitude;

  const shuffleArray = (array: any[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  return (
    <>
      <Header />
      <div className="border-b bg-white px-6 py-4 flex items-center justify-between">
        <div className="flex-1 mx-10">
          <ul className="flex space-x-8 text-gray-500 text-sm font-medium">
            {menuItems.map((item) => (
              <li
                key={item.label}
                className={`cursor-pointer pb-2 ${
                  activeSection === item.label
                    ? "text-pink-500 border-b-2 border-pink-500 font-semibold"
                    : "hover:text-pink-500"
                }`}
                onClick={() => scrollToSection(item.label, item.ref)}
              >
                {item.label}
              </li>
            ))}
          </ul>
        </div>
        {/* <button className="bg-pink-500 text-white px-6 py-2 rounded-md font-medium hover:bg-pink-600">
          Reserve Now
        </button> */}
      </div>

      {/* Image Carousel */}
      <div ref={photosRef} className="justify-center">
        <div className="container mx-auto px-4">
          {/* Top Section: Images */}
          <div className="px-0 m-0">
            <div className="md:w-full px-0 m-0">
              {/* Main Image */}
              <img
                src={
                  selectedProperty?.additional_information?.images &&
                  selectedProperty.additional_information.images.length > 0 &&
                  selectedProperty.additional_information.images[0] &&
                  selectedProperty.additional_information.images[0] !== "null"
                    ? selectedProperty.additional_information.images[0]
                    : pgImage
                }
                onClick={() => {
                  const media =
                    selectedProperty?.additional_information?.images || [];
                  const validMedia = media.filter(
                    (img: any) => img && img !== "null" && img !== ""
                  );
                  setModalMedia(validMedia);
                  setCurrentMediaIndex(0);
                  setIsModalOpen(true);
                }}
                alt="Property"
                className="w-full h-96 object-cover"
              />
            </div>

            {isModalOpen && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 ">
                <div className="bg-white rounded-lg overflow-hidden w-full h-full max-w-full max-h-full relative p-4 flex flex-col">
                  {/* Title & Close Button */}
                  <div className="flex justify-between items-center">
                    <div className="font-bold  text-2xl">
                      {`${selectedProperty.basic_details.propertyname}, ${selectedProperty.basic_details.city}`}
                    </div>
                    <button
                      onClick={() => {
                        setIsModalOpen(false);
                      }}
                      className="text-black-500 hover:text-gray-700 focus:outline-none text-3xl font-bold"
                    >
                      &times;
                    </button>
                  </div>

                  {/* Tabs for Occupancy Type */}
                  <div className="flex justify-center space-x-4 border-b pb-2 mt-2">
                    {occupancyTypes.map((type) => (
                      <button
                        key={type}
                        className={`px-4 py-2 font-semibold ${
                          activeTab === type
                            ? "text-pink-500 border-b-2 border-pink-600"
                            : "text-gray-500"
                        }`}
                        onClick={() => setActiveTab(type)}
                      >
                        {type}
                      </button>
                    ))}
                  </div>
                  <div className="overflow-auto p-2 ">
                    {/* Media Count */}
                    {/* <div className="text-lg flex justify-start font-semibold text-pink-500 text-center py-2">
                      Photos{`(${filteredMedia.filter((m: any) => !isVideo(m)).length})`}{" "}
                      | {" "}
                      Videos{`(${filteredMedia.filter((m: any) => isVideo(m)).length})`}
                    </div> */}

                    <div className="grid grid-cols-3 gap-4 ">
                      {filteredMedia.length > 0 ? (
                        filteredMedia.map((media: any, index: any) => (
                          <div
                            key={index}
                            className="relative cursor-pointer overflow-auto"
                            onClick={() => openModal(media, index)}
                          >
                            {isVideo(media) ? (
                              <div className="relative">
                                <video
                                  src={media}
                                  className="w-full h-full object-cover rounded-lg"
                                />
                                {/* Play Button Overlay */}
                                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-30 rounded-lg">
                                  <svg
                                    className="w-12 h-12 text-white"
                                    viewBox="0 0 24 24"
                                    fill="currentColor"
                                  >
                                    <path d="M8 5v14l11-7z" />
                                  </svg>
                                </div>
                              </div>
                            ) : (
                              <img
                                src={media}
                                alt="Media"
                                className="w-full h-full object-cover rounded-lg"
                              />
                            )}
                          </div>
                        ))
                      ) : (
                        <div className="col-span-3 text-center text-gray-700 text-lg p-4">
                          No Images or Videos Available
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {selectedMedia && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
                <div className="rounded-lg overflow-hidden max-w-full max-h-[90vh] p-6 relative">
                  <div className="w-full h-full flex items-center justify-center">
                    {renderMedia(selectedMedia)}
                  </div>
                </div>
              </div>
            )}

            {selectedMedia && (
              <div className="fixed inset-0 flex items-center justify-center bg-transparent z-50">
                <div className=" rounded-lg overflow-hidden max-h-[90vh]  flex justify-center items-center">
                  {/* Close Button */}
                  <button
                    onClick={() => {
                      setSelectedMedia(null);
                    }}
                    className="absolute top-0 right-2 text-white hover:text-white focus:outline-none text-3xl"
                  >
                    &times;
                  </button>
                  <div className="absolute top-1 left-1/2 transform -translate-x-1/2 text-white text-xl font-bold">
                    {mediaIndex + 1} / {filteredMedia.length}
                  </div>
                  {/* Previous Arrow (Left Side, Centered Vertically) */}
                  <button
                    onClick={goToPrevious}
                    className="absolute left-2 top-1/2 transform -translate-y-1/2
             text-white  
             bg-transparent border border-white rounded-full
             w-12 h-12 flex justify-center text-4xl "
                  >
                    &lt;
                  </button>

                  {/* Media Display */}
                  <div className="w-full flex justify-center items-center">
                    {renderMedia(selectedMedia)}
                  </div>

                  {/* Next Arrow (Right Side, Centered Vertically) */}
                  <button
                    onClick={goToNext}
                    className="absolute right-2 top-1/2 transform -translate-y-1/2
             text-white  
             bg-transparent border border-white rounded-full
             w-12 h-12 flex justify-center text-4xl "
                  >
                    &gt;
                  </button>
                </div>
              </div>
            )}
            {/* Property Info */}
            <div className="mx-20 relative top-[-40px]">
              <div className="md:w-full px-10 py-10 bg-white shadow-2xl rounded-2xl">
                <div className="flex flex-row items-center justify-between mb-3">
                  <div className="flex items-center">
                    <h1 className="text-2xl font-bold">
                      {selectedProperty?.basic_details?.propertyname}
                    </h1>
                    <span className="text-yellow-400 ml-5">
                      ★ {reviews?.overallRating}
                    </span>
                  </div>
                  {/* <div className="flex items-center">
                    <span className=" ml-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                        />
                      </svg>
                    </span>
                    <span className="ml-5">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="size-7"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z"
                        />
                      </svg>
                    </span>
                  </div> */}
                </div>
                <div className="text-lg flex-col font-semibold">
                  <p className="text-sm text-gray-500">Starts from</p>
                  <h3>₹{selectedProperty?.lowestRent}/month*</h3>
                </div>

                {/* "View on Map" Button */}
                <div className="mt-2">
                  <button
                    className="text-blue-500 hover:underline flex items-center"
                    onClick={() => {
                      mapRef.current?.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                      });
                    }}
                  >
                    <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />
                    View on Map
                  </button>
                </div>

                {/* Available Occupancies */}
                <div ref={occupancyRef} className="mt-4 space-y-4">
                  <h2 className="text-xl font-semibold">
                    Available Occupancies
                  </h2>
                  <div className="flex space-x-4">
                    {Object.entries(groupedRooms ?? {}).map(
                      ([shareType, details]) => (
                        <div key={shareType} className="p-4 border rounded-lg">
                          <h3 className="font-bold text-pink-500">
                            {shareType}
                          </h3>
                          <p className="text-sm text-gray-500">
                            {details?.beds} beds available
                          </p>
                          <p className="text-sm text-gray-500">Starts from</p>
                          <p className="text-sm">
                            ₹{details?.lowestPrice}/month
                          </p>
                        </div>
                      )
                    )}
                  </div>
                </div>
                <div ref={amenitiesRef} className="mt-8">
                  <h2 className="text-xl font-semibold">Amenities</h2>
                  <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4">
                    {property?.amenities?.amenties
                      .slice(
                        0,
                        showAllAmenities
                          ? property.amenities.amenties.length
                          : 8
                      )
                      .map((amenity: any, index: any) => (
                        <div
                          key={index}
                          className="p-4 border rounded-lg flex flex-col items-center"
                        >
                          <img
                            src={amenity.ameneties_images}
                            alt={amenity.ameneties_name}
                            className="w-10 h-10 object-cover"
                          />
                          <p>{amenity.ameneties_name}</p>
                        </div>
                      ))}
                  </div>
                  {!showAllAmenities && (
                    <button
                      className="mt-5 text-sm text-pink-500 underline"
                      onClick={handleViewAllAmenities}
                    >
                      View All Amenities
                    </button>
                  )}
                  <p className="text-sm mt-3 text-gray-500">
                    * Amenities differ by room, choose room accordingly
                  </p>
                </div>
              </div>
              <div ref={mapRef} className="mt-8">
                <MapSection
                  cityName={selectedProperty?.basic_details?.city}
                  // cityName={"Chennai"}
                  lat={latitude}
                  lng={longitude}
                />
              </div>
            </div>

            {/* Reviews Section */}
            <div ref={reviewsRef}>
              <ReviewsSection reviews={reviews} />
              <hr />
            </div>
            <div>
              <ReviewCards
                data={Array.isArray(allReviewMesg) ? allReviewMesg : []}
              />
            </div>
            <div>
              <PropertiesList data={trendings} />
            </div>
          </div>
        </div>
        <div ref={similarPropertiesRef} className="mt-8 ml-8">
          <h2 className="ml-20 text-xl font-semibold">
            Other Similar Properties
          </h2>
          <div className="flex gap-8 justify-center p-8">
            {shuffleArray([...propertiesData]).slice(0, 3).map((property: any, index: any) => (
              <div
                key={property.propertyId || index}
                onClick={() =>
                  handlePropertyClick(property.propertyId, propertiesData)
                }
                className="border rounded-lg overflow-hidden shadow-lg w-80 cursor-pointer hover:shadow-2xl transition-shadow duration-300"
              >
                <div className="border rounded-lg overflow-hidden shadow-lg w-80">
                  {/* Image & Favorite Icon */}
                  <div className="relative">
                    <img
                      src={property.additional_information.images[0]}
                      alt={property.basic_details.propertyname}
                      className="w-full h-48 object-cover"
                    />
                    {/* Heart (Favorite) Icon */}
                    <button
                      type="button"
                      className="absolute top-2 right-2 bg-white rounded-full p-2 shadow hover:bg-gray-100 transition"
                    >
                      <HeartIcon className="text-gray-600" size={18} />
                    </button>
                  </div>

                  {/* Card Content */}
                  <div className="p-4">
                    {/* Top Section: Title, Rating, PG Type */}
                    <div className="flex items-start justify-between">
                      <h2 className="text-lg font-semibold text-gray-800">
                        {property.basic_details.propertyname}
                      </h2>
                      <div className="flex items-center space-x-2">
                        {/* Star Rating */}
                        <div className="flex items-center space-x-1 text-yellow-400">
                          <FontAwesomeIcon icon={faStar} />
                          <span className="text-sm text-gray-800 font-medium">
                            {property.overallRating}
                          </span>
                        </div>
                        {/* PG Type Badge */}
                        <span
                          className={`text-xs font-medium px-2 py-1 rounded-full ${
                            property.property_information.pgType === "Women"
                              ? "bg-pink-500 text-white"
                              : "bg-blue-500 text-white"
                          }`}
                        >
                          {property.property_information.pgType}
                        </span>
                      </div>
                    </div>

                    {/* Location / Distance / Rent Info */}
                    <p className="text-gray-600 mt-1">
                      {property.basic_details.city},{" "}
                      {property.basic_details.houseArea}
                    </p>
                    <p className="text-gray-500 text-sm mt-1">
                      {property.distanceTime ||
                        "9.1km away from your location / 30mins"}
                    </p>

                    <p className="text-gray-700 font-semibold mt-3">
                      Starts from{" "}
                      <span className="text-indigo-600">
                        ₹{property.lowestRent}/month
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default PropertyDetails;
